import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { inviteCodeFrom } from '../lib/inviteLink';
import s from './Landing.module.css';

/** "Have the link? Paste it here" → /join/<code>. */
export function InvitePaste() {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [invalid, setInvalid] = useState(false);

  function submit(e: FormEvent) {
    e.preventDefault();
    const code = inviteCodeFrom(value);
    if (code) navigate(`/join/${code}`);
    else setInvalid(true);
  }

  return (
    <form className={s.paste} onSubmit={submit}>
      <label htmlFor="invite" className={s.pasteLabel}>
        Have the link? Paste it here
      </label>
      <div className={s.pasteRow}>
        <input
          id="invite"
          className={s.pasteInput}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setInvalid(false);
          }}
          placeholder="https://…/join/…"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          inputMode="url"
        />
        <button className={s.primary} type="submit" disabled={!value.trim()}>
          Open
        </button>
      </div>
      {invalid && <p className={s.pasteError}>That doesn't look like an invite link.</p>}
    </form>
  );
}
